import { toProviderSlug } from '@infinitro/catalog-min';
const normalizeKey = (provSlug) => toProviderSlug(provSlug || '')
    .toLowerCase()
    .trim();
/**
 * Map of normalized provider slug → override. Edit this object only; no entry ⇒ unchanged logo.
 */
export const PROVIDER_LOGO_OVERRIDES = {
    'pragmatic-play': {
        width: 'auto',
        height: '55px',
        transform: 'translate(0, -3px) translateZ(0)'
    },
    'pragmatic-play-live': {
        width: 'auto',
        height: '55px',
        transform: 'translate(0, -3px) translateZ(0)'
    }
};
function buildInlineStyle(override) {
    const parts = [];
    if (override.width)
        parts.push(`width:${override.width}`);
    if (override.height)
        parts.push(`height:${override.height}`);
    if (override.maxWidth)
        parts.push(`max-width:${override.maxWidth}`);
    if (override.maxHeight)
        parts.push(`max-height:${override.maxHeight}`);
    if (override.transform)
        parts.push(`transform:${override.transform}`);
    if (override.objectFit)
        parts.push(`object-fit:${override.objectFit}`);
    if (override.objectPosition)
        parts.push(`object-position:${override.objectPosition}`);
    if (override.marginTop)
        parts.push(`margin-top:${override.marginTop}`);
    if (override.marginRight)
        parts.push(`margin-right:${override.marginRight}`);
    if (override.marginBottom)
        parts.push(`margin-bottom:${override.marginBottom}`);
    if (override.marginLeft)
        parts.push(`margin-left:${override.marginLeft}`);
    if (override.style)
        parts.push(override.style.replace(/;+\s*$/, ''));
    return parts.join(';');
}
/**
 * Inline style string for a provider logo `<img>`, or `undefined` when there is no override.
 */
export function getProviderLogoInlineStyle(provSlug) {
    const o = PROVIDER_LOGO_OVERRIDES[normalizeKey(provSlug)];
    if (!o)
        return undefined;
    const s = buildInlineStyle(o);
    return s.length > 0 ? s : undefined;
}
